import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button, Dialog, Classes
} from '@blueprintjs/core';
import {
  SipSettingErrors,
  SipInfo,
  SipTimer,
  SipPrefix,
  SipNetworkElements,
} from 'data/sipSetting/sipSetting.types';
import './errors-dialog.scss';

type Props = {
  data: SipSettingErrors
}

const ErrorsDialog = ({ data }: Props) => {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(true);

  useEffect(() => {
    setOpen(data.hasError);
  }, [data]);

  const handleCLose = () => {
    setOpen(false);
  }

  const renderError = (item: { error: string, data: SipInfo | SipTimer | SipPrefix | SipNetworkElements }) => <li key={item.error} className="errors-dialog-errors-item">{item.error}</li>;

  const renderErrorSection = (title: string, errors: { error: string, data: SipInfo | SipTimer | SipPrefix | SipNetworkElements }[]) => {
    if (errors == null || errors?.length <= 0) {
      return null;
    }

    return (
      <div className="errors-dialog-section">
        <h5 className="errors-dialog-section-title">{title}:</h5>
        <ul className="errors-dialog-errors">
          {errors.map(renderError)}
        </ul>
      </div>
    );
  }

  return (
    <Dialog isOpen={isOpen} title={t('sipSetting.form.dialog.title')} onClose={handleCLose} className="errors-dialog">
      <div className="errors-dialog-body">
        <p className="errors-dialog-note">{t('sipSetting.form.dialog.note')}</p>
        <div className="errors-dialog-sections">
          {renderErrorSection(t('sipSetting.form.dialog.info'), data.sipInfo)}
          {renderErrorSection(t('sipSetting.form.dialog.timer'), data.sipTimer)}
          {renderErrorSection(t('sipSetting.form.dialog.prefix'), data.prefixes)}
          {renderErrorSection(t('sipSetting.form.dialog.net'), data.networkElements)}
        </div>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={handleCLose} intent="primary" text={t('common.button.ok')} />
        </div>
      </div>
    </Dialog>
  )
}

export default ErrorsDialog;
